import { useEffect, useRef } from "react";

import i18next from "i18next";
import moment from "moment";
import { useDispatch } from "react-redux";

import { useLocalStorage } from "../../hooks";
import { setAppConfigs } from "../../store/appConfigsSlice";
import { getRequisites } from "../../protocols";
import { appDefaultLanguage } from "../../config";

const ConfigurationProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { getItem, setItem } = useLocalStorage();
  const params = new URLSearchParams(document.location.search);

  const getRequisiteRequest = useRef(async () => {
    try {
      const result = await getRequisites();

      const { available_currencies, available_languages } = result?.data || {};
      configureCurrencies(available_currencies);
      configureLocalization(available_languages);
    } catch (error) {
      console.log({ error });
    }
  });

  useEffect(() => {
    getRequisiteRequest.current();
  }, []);

  const configureCurrencies = availableCurrencies => {
    // раньше выбор из меню писался сырой строкой, а не JSON — читаем оба формата
    const localCurrency = getItem("currency") ?? getItem("currency", true);
    const { available_currencies } = JSON.parse(availableCurrencies);

    if (localCurrency && available_currencies.includes(localCurrency)) {
      dispatch(
        setAppConfigs({
          currency: localCurrency,
          availableCurrencies: available_currencies,
        })
      );
    } else {
      dispatch(
        setAppConfigs({
          currency: available_currencies[0],
          availableCurrencies: available_currencies,
        })
      );

      setItem("currency", available_currencies[0]);
    }
  };

  const configureLocalization = availableLanguages => {
    const languages = JSON.parse(availableLanguages).reduce((acc, current) => {
      acc.push(current.lang_code);

      return acc;
    }, []);

    const urlLocale = params.get("locale") || params.get("lang");

    let currentLanguage =
      typeof window !== "undefined"
        ? window.localStorage.getItem("language") || appDefaultLanguage
        : appDefaultLanguage;

    if (!languages.includes(currentLanguage)) {
      currentLanguage = languages[0];
    }

    if (urlLocale && languages.includes(urlLocale)) {
      currentLanguage = urlLocale;
      setItem("language", urlLocale);
    }

    if (currentLanguage !== i18next.language) {
      i18next.changeLanguage(currentLanguage);
    }

    dispatch(
      setAppConfigs({
        availableLanguages: languages,
        language: currentLanguage,
      })
    );

    moment.updateLocale(currentLanguage === "tj" ? "tg" : currentLanguage, { week: { dow: 1 } });
  };

  return children;
};

export default ConfigurationProvider;
